export const environment = {
  production: false,
  apiUrl: 'https://api.dev.citalinkpro.com',
  googleClientId:
    '872916616153-qcbtapk8kh3fa3j1dobosjfhujthlkda.apps.googleusercontent.com',
  epaycoLoaderCheckoutUrl: 'https://checkout.epayco.co/checkout.js',
  epaycoPublicKey: '0e45fa2c1ee4831b1450bad7fab874cb',
  epaycoTestMode: true,
  epaycoWebhookUrl:
    'https://api.dev.citalinkpro.com/api/v1/membership/epayco/webhook',
};
